const i18n = JSON.parse(document.querySelector('.mfooter-accessibility [data-translations]').innerText);
const contrastSwitch = document.querySelector('.mfooter-accessibility #switch_contrast');
const contrastSwitchCheck = document.querySelector('.mfooter-accessibility .switch-check');

const applyContrastState = (isHighContrast) => {
    document.body.classList.toggle('high-contrast', isHighContrast);
    if (isHighContrast) {
        document.body.setAttribute('data-contrast', 'high');
    } else {
        document.body.removeAttribute('data-contrast');
    }
    const label = isHighContrast ? i18n.highContrastOff_Label : i18n.highContrastOn_Label;
    contrastSwitch.setAttribute('title', label);
    contrastSwitch.setAttribute('aria-label', label);
    contrastSwitch.checked = isHighContrast;
    contrastSwitchCheck.setAttribute('data-ats-accessibility-button', isHighContrast ? 'on' : 'off');
    if (window.localStorage) {
        if (isHighContrast) {
            window.localStorage.setItem('high-contrast', 'true');
        } else {
            window.localStorage.removeItem('high-contrast');
        }
    }
};

contrastSwitch.addEventListener('change', (e) => {
    e.stopPropagation();
    applyContrastState(e.currentTarget.checked);
});

if (window.localStorage && window.localStorage.getItem('high-contrast') === 'true') {
    applyContrastState(true);
}
